/*
 * Copyright (c) 2024 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain
 * proprietary information of OCLC, Inc. and shall not be disclosed in whole or in
 * any part to any third party or used by any person for any purpose, without written
 * consent of OCLC, Inc.  Duplication of any portion of these  materials shall include this notice.
 *
 */

import { Box, styled } from '@mui/material';

const StyledErrorDetails = styled(Box)(({ theme }) => ({
  margin: 0,

  '& .error-detail': {
    padding: theme.spacing(2),
    paddingLeft: '0px',
    overflowWrap: 'anywhere',
  },

  '& dt': {
    height: '24px',
    fontWeight: 600,
  },

  '& dd': {
    marginLeft: '32px',
  },
}));

export { StyledErrorDetails };
